<template>
    <b-row class="m-0">
        <b-col class="p-0" md="auto">
            <b-icon v-if="Modify"
                    v-b-tooltip.noninteractive.hover
                    :title="'Des informations ont été modifiés'"
                    :variant="Variant"
                    class="position-absolute end-0 translate-middle rounded-pill mt-1"
                    icon="exclamation-circle-fill"
                    role="button"
                    scale="0.75"
                    style="z-index:1 !important"
                    v-on="$listeners"/>
            <ButtonIconComplexe :ButtonInsideClass="ButtonInsideClass"
                                :ContentClass="ContentClass"
                                :Disabled="Disabled"
                                :FeatureName="FeatureName"
                                :IconClass="IconClass"
                                :ParametersOverride="saveParameters"
                                :Type="type"
                                :VariantOverride="VariantOverrideSave"
                                :Outline="Outline"
                                v-bind="Object.assign($attrs, $options.propsData, $listeners)"
                                v-on="$listeners">
                <template slot="icon">
                    <i class="bi-floppy"/>
                </template>
            </ButtonIconComplexe>
        </b-col>
    </b-row>
</template>

<script lang="ts">
import {Component, Prop} from 'vue-property-decorator';
import ButtonIcon from "../ButtonIcon";
import ButtonIconComplexe from "./ButtonIconComplexe.vue";
import IButtonParameters from "../../IButtonParameters";
import IconParameters from "./ButtonIconSimpleParameters";

@Component({
    components: {ButtonIconComplexe},
    i18n: ButtonIcon.MessageLocales()
})
export default class ButtonIconComplexeSave extends ButtonIcon {
    /** Facultatif : Class attaché à l'icône pour des besoins de debug */
    @Prop({default: () => false})
    public Modify!: boolean;

    @Prop({default: () => "dark"})
    public VariantOverrideSave!: string;

    private type: string = "Save";
    private saveParameters: IButtonParameters = new IconParameters('Write', {icon: 'bi-floppy', tooltip: 'Save'});

    constructor() {
        super();
    }
}
</script>

<style scoped>

</style>